module.exports = __webpack_public_path__ + "img/edit.36a59da0.svg";